const validMailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i;

const validPhoneNumberRegex =/^[+]?[0-9 ]{6,30}$/i

export function validateEmail(s: string): boolean {
    return s && validMailRegex.test(s);
}

export function stringLengthCheck(s: string, minLength: number = -1, maxLength: number = -1): boolean {

    if(s) {
        if(minLength > 0 && s.length < minLength) return false;
        if(maxLength > 0 && s.length > maxLength) return false;
        return true;
    }
    return false;
}


export function validPhoneNumber(s: string): boolean {
    return s && validPhoneNumberRegex.test(s);
}



export function parseDate(s: string): Date {
    if(s) {
        return new Date(s);
    }
    else return null;
}

export function validDate(s: string, minDate: Date = null, maxDate: Date=null): boolean {
    const date = parseDate(s);
    //console.log("Parsed date is",date);
    if(date) {
        if(minDate && date.getTime() < minDate.getTime()) return false;
        if(maxDate && date.getTime() > maxDate.getTime()) return false;
        return true;
    }

    return false;
}

export function daysBeforeNow(days: number): Date {
    return new Date(Date.now() - (86400000*days));
}

export function yearsBeforeNow(years: number): Date {
    return daysBeforeNow(years*365);
}





export function validateFormData(data: any): string[] {

    const errors: string[] = [];

    if(!validateEmail(data.email)) {
        errors.push("Email non valida");
    }
    if(!stringLengthCheck(data.fullname,5)) {
        errors.push("Nome e Cognome non validi");
    }
    if(!validDate(data.date,new Date(-2208992400000),yearsBeforeNow(4))) {
        errors.push("Data di nascita non valida");
    }
    if(!validPhoneNumber(data.phone)) {
        errors.push("Numero di telefono non valido");
    }

    if(!stringLengthCheck(data.address,5)) {
        errors.push("Indirizzo non valido");
    }
    if(!stringLengthCheck(data.socials,5)) {
        errors.push("Link social non validi");
    }

    if(!stringLengthCheck(data.job,1)) {
        errors.push("Attuale lavoro non inserito");
    }

    if (!stringLengthCheck(data.management, 1)) {
        errors.push("Va indicato se hai un'agenzia di management");
    }

    if (!stringLengthCheck(data.journalist, 1)) {
        errors.push("Va indicato se sei un giornalista");
    }

    return errors;
}